import { AZURE_LOGIN } from "./actionType";

const initialState = {
    azure_code: '',

};

const azure_login = (state = initialState, action) => {

  switch (action.type) {
    case AZURE_LOGIN:
        console.log('azure',action)
       state = {
            ...state,
            azure_code: action.payload,
          };
          console.log('azure state',state)

      break;  
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default azure_login;
